import api from 'api';

export const loadStatuses = api('GET /api/affiliates/filters/statuses');

export const loadPartnerCompanies = api(
  'GET /api/affiliates/filters/partner-companies'
);

export const loadBusinessPartners = api(
  'GET /api/affiliates/filters/business-partners'
);

export const loadNetworks = api('GET /api/affiliates/filters/networks');

export const loadApplications = api('GET /api/affiliates/filters/applications');

export const loadPlatforms = api('GET /api/affiliates/filters/platforms');

export const loadClusters = api('GET /api/affiliates/filters/clusters');

export const loadTrafficTypes = api(
  'GET /api/affiliates/filters/traffic-types'
);

export const loadExpenseTypes = api(
  'GET /api/affiliates/filters/expense-types'
);

export const loadOwners = api('GET /api/affiliates/filters/owners');

export const loadCreatedBy = api('GET /api/affiliates/filters/created-by');

export const loadChannels = api('GET /api/affiliates/filters/channels');

export const loadChannelType = api('GET /api/affiliates/filters/channel-types');
